import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AdminSettingLayer from "../../components/AdminSetting/AdminSettingLayer";


const AdminSettingPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Settings" />

        {/* Setting */}
        <AdminSettingLayer />

      </MasterLayout>

    </>
  );
};

export default AdminSettingPage; 
